<template>
  <div class="registration-confirmed">
    <div>
      <img src="/assets/images/email-confirmation.svg" alt="" class="confirmation-icon"/>
      <h1 class="title">{{ $t('registration.emailConfirmation.title') }}</h1>
      <p class="description" v-html="$t('registration.emailConfirmation.description')"></p>

      <base-button class="confirmation-button" @click="sendAgain" :loading="dataLoading">
        {{ $t('registration.emailConfirmation.sendAgain') }}
      </base-button>
    </div>
    <div class="bottom-description">
      <hr>
      <span class="small-text">{{ $t('registration.emailConfirmation.linkLabel') }}</span>
    </div>
  </div>
</template>

<script>

import { addDataLayerEvent } from '@/services/dataLayer'
import { lsGet, lsRemove } from '@/utils/localStorageController'
import { customRouter } from '@/customRouter'

export default {
  name: 'page-registration-email-sent',
  data () {
    return {
      email: '',
      dataLoading: false
    }
  },
  methods: {
    sendAgain () {
      this.dataLoading = true
      const token = lsGet('sc_registration').token
      if (token) {
        const verifyRegLink = window.location.origin + customRouter.getRouteByName({ name: 'verifyRegistration' })
        this.$apiRequest.post('register/resendemail', { link: verifyRegLink, token: token })
          .then(() => {
            this.toast('success', {
              message: this.$t('registration.emailConfirmation.mailSentAgainMessage')
            })
          })
          .catch(e => {
            if (e.response.data.errors && e.response.data.errors.length) {
              this.toast('error', {
                message: e.response.data.errors[0].message || this.$t('errors.defaultError')
              })
            } else {
              this.toast('error', {
                message: this.$t('errors.defaultError')
              })
            }

            lsRemove('sc_registration')
            setTimeout(() => {
              customRouter.goTo({ name: 'registration' })
            }, 2000)
          })
          .finally(() => {
            this.dataLoading = false
          })
      }
      addDataLayerEvent('posalji_ponovo')
    }
  }
}
</script>

<style scoped lang="scss">
.registration-confirmed {
  margin: 0 auto;
  width: 100%;
  max-width: 68rem;
  background-color: $white;
  border-radius: 5px;
  text-align: center;
  padding: 4rem 4rem 2.4rem;
  height: calc(100vh - 67px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (map_get($breakpoints, sm)) {
    margin-top: 13rem;
    height: auto;
    padding: 4rem;
  }

  @media (map_get($breakpoints, md)) {
    margin-top: 16rem;
    max-width: 84rem;
  }

  .title {
    font-size: 3.2rem;
    font-weight: normal;
    margin-top: 2.4rem;
    margin-bottom: 4rem;
    color: $text;
  }

  .description {
    color: $text-alt;
    margin: 0 auto;
    margin-bottom: 4rem;
    max-width: 60rem;
  }

  .confirmation-button {
    width: 100%;

    @media (map_get($breakpoints, sm)) {
      width: auto;
    }
  }

  hr {
     margin-bottom: 1.6rem;
    @media (map_get($breakpoints, sm)) {
      width: 40rem;
      margin: 8rem auto 1.6rem;
      border-top: 1px solid #e1e1e1;
    }
  }

  .small-text {
    font-size: 1.2rem;
    color: #777777;
  }
}
</style>
